/**
 * The custom element the checkout is mounted as, shared by everything that needs
 * to talk to the page hosting it: the DOM event contract dispatches on it, and
 * the analytics context an embedder states in its markup is read from it.
 */

/** The custom elements the checkout is mounted as, most general first. */
export const WIDGET_ELEMENT_NAMES = ["guest-checkout", "place-your-order", "secure-your-booking"] as const;

/**
 * The custom element the checkout is mounted in, or `null` in the standalone
 * build, where no custom element exists.
 */
export function resolveWidgetElement(): Element | null {
  for (const name of WIDGET_ELEMENT_NAMES) {
    const element = document.querySelector(name);
    if (element) return element;
  }

  return null;
}
